export default __webpack_public_path__ + "static/Plots0070-b6195cf31ed8f6642baa92e24dea5647.jpg";